var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "plans-switch size-lg",
      attrs: { for: "filter", "aria-label": "Toggle Standard and Plus Plans" },
    },
    [
      _c("label", { staticClass: "margin-0" }, [
        _c("input", {
          staticClass: "plus sr-only",
          attrs: { id: "plus", type: "radio", name: "plans", value: "plus" },
          domProps: { checked: _vm.value === "plus" },
          on: { change: _vm.togglePlans },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "margin-0" }, [
        _c("input", {
          staticClass: "standard sr-only",
          attrs: { id: "standard", type: "radio", name: "plans", value: "pro" },
          domProps: { checked: _vm.value === "pro" },
          on: { change: _vm.togglePlans },
        }),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("i", {
        staticClass: "slider-icon fa-solid fa-sparkles margin-right-2xs",
      }),
      _vm._v(" Pro+ Plans"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("i", {
        staticClass: "slider-icon fa-solid fa-globe margin-right-2xs",
      }),
      _vm._v(" Pro Plans"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }